export default __webpack_public_path__ + "static/media/015-rocket launch.4a141cb5.svg";